import { Col } from "antd"
import styled from "styled-components"

export const StyleDetailCourse = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 350px;
  .item-des {
    max-width: 100%;
    height: 250px;
    overflow: hidden auto;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
  .course-title {
    font-weight: 600;
    font-size: 16px;
    color: #154398;
  }
  .course-content {
    font-weight: 400;
    font-size: 14px;
    color: #212529;
    margin-bottom: 8px;
    height: 0;
    flex: auto;
  }
  .course-content-detail {
    ul {
      margin-bottom: 24px;
      li {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        list-style-type: none;
        margin-top: 8px;
        span {
          margin-right: 8px;
        }
      }
    }
  }
  .add-cart-btn {
    button {
      border: none;
      outline: none;
      justify-content: center;
      width: 311px;
      height: 56px !important;
      background: #00c590;
      border-radius: 4px !important;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      color: #ffffff;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        :first-child {
          margin-right: 10px;
        }
      }
    }
  }
`
export const CourseItemStyle = styled(Col)`
  .pg-size {
    align-items: flex-end;
  }
  .img-course {
    height: 200;
    position: relative;
    .bg-course-name {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: linear-gradient(#ffffff00, #000);
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      color: #fff;
      padding: 16px;
      font-weight: 600;
    }
  }
  .ant-card-body {
    padding: 24px 16px;
  }
  .ant-ribbon {
    right: -6px;
    top: 5px;
  }
  .hidden-ribbon {
    .ant-ribbon-text,
    .ant-ribbon-corner {
      display: none;
    }
  }
  .card-course {
    box-shadow: 0 2px 4px rgb(0 0 0 / 8%), 0 4px 12px rgb(0 0 0 / 8%);
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    &:hover {
      box-shadow: 0 4px 8px #62b0fd, 0 4px 12px rgb(0 0 0 / 8%);
    }
    .ant-card-meta-title {
      white-space: unset;
      min-height: 50px;
    }
    .teacher-name {
      font-weight: 600;
      font-size: 12px;
      color: #333;
    }
    .old-price {
      text-decoration: line-through;
      font-size: 12px;
    }
    .new-price {
      font-weight: 600;
      font-size: 14px;
      color: #333;
    }
  }
`
